export const socialsData = {
    github: 'https://github.com/AnandaGouda',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/ananda-gouda-b23818209/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/goudaanand65',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}